// extracted by mini-css-extract-plugin
export default {"loader":"kad4aMkr"};